import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RequirementReferenceWorkspace } from 'api';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'comp-reference-elements',
  templateUrl: './reference-elements.component.html',
  styleUrls: ['./reference-elements.component.scss'],
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferenceElementsComponent {
  readonly referenceWorkspaces = input.required<Array<RequirementReferenceWorkspace>>();
}
